import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGraphQLThunk, createMultipartGraphQLThunk } from ".";
import { GET_VENDOR_BY_ID, UPDATE_PORTAL_USER, UPDATE_PORTAL_USER_PASSWORD } from "../../utils/queries";

export const updatePortalUserThunk = createAsyncThunk(
  "updatePortalUserSlice/updatePortalUserThunk",
  createMultipartGraphQLThunk({
    query: UPDATE_PORTAL_USER,
    getVariables: ({ payload, profilePicture }) => ({
      payload,
      profilePicture,
    }),
    responseKey: "updatePortalUser",
    fileKey: "profilePicture",
    url: process.env.REACT_APP_USER,
    onSuccessMessage: "Profile updated successfully!"
  })
);

export const updatePortalPasswordThunk = createAsyncThunk(
  "updatePortalPasswordSlice/updatePortalPasswordThunk",
  createMultipartGraphQLThunk({
    query: UPDATE_PORTAL_USER_PASSWORD,
    getVariables: ({ myPasswordInput }) => ({
      myPasswordInput
    }),
    responseKey: "changeMyPassword",
    url: process.env.REACT_APP_USER,
    onSuccessMessage: "Password updated successfully!"
  })
);

export const getVendorById = createAsyncThunk(
  "getVendorByIdSlice/getVendorById",
  createGraphQLThunk({
    query: GET_VENDOR_BY_ID,
    getVariables: ({ id }) => ({id}),
    responseKey: "getUserById",
    url: process.env.REACT_APP_USER
  })
)
